var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2068_13104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 0.25H23.8711V21.935H0.75V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2068_13104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3088 2.125C7.94002 2.125 4.89502 5.5475 4.89502 8.61875C4.89502 11.2175 4.17377 12.4187 3.53627 13.4788C3.02502 14.33 2.62127 15.0025 2.62127 16.4637C2.83002 18.8212 4.38627 20.06 12.3088 20.06C20.1875 20.06 21.7925 18.7663 22 16.3825C21.9963 15.0025 21.5925 14.33 21.0813 13.4788C20.4438 12.4187 19.7225 11.2175 19.7225 8.61875C19.7225 5.5475 16.6775 2.125 12.3088 2.125ZM12.3088 21.935C6.46377 21.935 1.18127 21.5225 0.750017 16.5438C0.746267 14.4837 1.37502 13.4362 1.93002 12.5138C2.49127 11.5787 3.02002 10.6975 3.02002 8.61875C3.02002 4.5775 6.75252 0.25 12.3088 0.25C17.865 0.25 21.5975 4.5775 21.5975 8.61875C21.5975 10.6975 22.1263 11.5787 22.6875 12.5138C23.2425 13.4362 23.8713 14.4837 23.8713 16.4637C23.435 21.5225 18.1538 21.935 12.3088 21.935Z",
    fill: "#7B47CC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2502 27.1248H12.2477C10.8465 27.1235 9.52022 26.506 8.51397 25.3848C8.16772 25.001 8.19897 24.4073 8.58397 24.0623C8.96897 23.7148 9.56147 23.746 9.90772 24.1323C10.5552 24.8535 11.3865 25.2498 12.249 25.2498H12.2502C13.1165 25.2498 13.9515 24.8535 14.6002 24.131C14.9477 23.7473 15.5402 23.716 15.924 24.0623C16.309 24.4085 16.3402 25.0023 15.994 25.386C14.984 26.5073 13.6552 27.1248 12.2502 27.1248Z",
    fill: "#7B47CC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNot);
export default __webpack_public_path__ + "static/media/not.9c3d37d7da965ce9f1295bf419b878de.svg";
export { ForwardRef as ReactComponent };